// JobSeekers/index.jsx — the student / job seeker landing page ("/job-seekers").
// Section order: hero, features, results, anyone, stories, integrations,
// Chrome extension, FAQ, closing CTA.
// (Situations scroller replaces the earlier three-step journey module;
//  the employer marks now close the stories section rather than standing
//  alone as Trusted. The integrations map holds the slot the sign-up callout
//  briefly took. Adaptive and the pricing callout are commented out.)
// Shares the home page's design tokens by carrying the .home-page class, so
// type scale, palette and primitives all come from homePage.css.
import StudentHero from "./Hero/StudentHero";
import Features from "./Features/Features";
import Results from "./Results/Results";
import Anyone from "./Anyone/Anyone";
import Stories from "./Stories/Stories";
// import Adaptive from "./Adaptive/Adaptive";
// import PricingCallout from "./Pricing/PricingCallout";
import Integrations from "./Integrations/Integrations";
import Extension from "./Extension/Extension";
import Faq from "./Faq/Faq";
import FinalCta from "./FinalCta/FinalCta";
import Seo from "../../seo/Seo";
import "../HomePage/homePage.css";
import "./students.css";

const JobSeekersPage = () => (
  <div className="home-page students-page">
    <Seo path="/job-seekers" />
    <StudentHero />
    <Features />
    <Results />
    <Anyone />
    {/* <Adaptive /> */}
    <Stories />
    {/* <PricingCallout /> */}
    <Integrations />
    <Extension />
    <Faq />
    <FinalCta />
  </div>
);

export default JobSeekersPage;
